import React, { Component } from 'react';

import firebase from 'firebase/app';
import 'firebase/firestore';

import ShareScore from './ShareScore';
import DeleteScore from '../helpers/DeleteScore';
import ButtonAppBar from './material-ui/ButtonAppBar';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import * as moment from 'moment';
import NoteInputField from './material-ui/NoteInputField';


const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        padding: '1px'
    },        
});

const noPadding = {
    padding: '1px',
    width: '100%',
    maxWidth: 360,
}

class PersonFocus extends Component {

    unsubPerson;
    unsubHistory;

    constructor(props) {
        super(props);
        this.state = {
            personFS: null,
            personHistoryFS: [],
            pointsToAdd: '',
            note: '',
            showShareForm: false,
            menuOpen: null,
        };
        this.db = firebase.firestore();

        this.showShareScore= this.showShareScore.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.handleMenuChange = this.handleMenuChange.bind(this);

    }

    startListeners() {
        var docId = this.props.match.params.id;

        this.unsubPerson = this.db.collection("persons").doc(docId)
            .onSnapshot(
                docSnapshot => {
                    this.setState({ personFS: docSnapshot });
                }
            );

        this.unsubHistory = this.db.collection("persons").doc(docId).collection("history")
            .orderBy("created", "desc")
            .onSnapshot(
                querySnapshot => {
                    this.setState({ personHistoryFS: querySnapshot.docs });
                }
            );
    }

    componentDidMount() {
        this.startListeners();
    }

    componentWillUnmount() {
        this.unsubPerson();
        this.unsubHistory();
    }


    isReadOnly() {
        var isReadOnlyPerm = true;
        var uid = firebase.auth().currentUser.uid;
        try {
            var perm = this.state.personFS.data().permissionWrite;
        }
        catch (err) { // the firestore object is not ready yet.
            return true;
        }

        if (uid in perm) {
            isReadOnlyPerm = false;
        };
        return isReadOnlyPerm
    }

    handleSubmit(event) {
        if(!this.state.pointsToAdd && !this.state.note){
            event.preventDefault();
            this.props.history.push('/');
            return;
        }
        var docId = this.props.match.params.id;
        var user = firebase.auth().currentUser;
        var pointsBeforeAdd = this.state.personFS.data().points;
        this.db.collection("persons").doc(docId).collection("history").add({
            changedByEmail: user.email,
            changedByUID: user.uid,
            created: firebase.firestore.FieldValue.serverTimestamp(),
            isRequest: this.isReadOnly(),
            note: this.state.note,
            personID: docId,
            pointsAdd: Number(this.state.pointsToAdd),
            pointsBefore: pointsBeforeAdd,
        })
            .then(function () {
                console.log("history Document successfully written!");
            })
            .catch(function (error) {
                console.error("Error writing document: ", error);
            });

        var personUpdateObj = {
            hasOpenRequest: true
        }

        if (!this.isReadOnly()){
            personUpdateObj = {
                points: pointsBeforeAdd + Number(this.state.pointsToAdd),
                lastPointsAdd: Number(this.state.pointsToAdd),
                note: this.state.note,
                lastUpdate: firebase.firestore.FieldValue.serverTimestamp(),
                hasOpenRequest: false,
            }
        }
        
        
        this.db.collection("persons").doc(docId).update(personUpdateObj)
            .then(function () {
                console.log("person Document successfully updated!");
            })
            .catch(function (error) {
                console.error("Error writing document: ", error);
            });
        
        event.preventDefault();
        this.setState({
            pointsToAdd: '',
            note: ''
        })

        this.props.history.push('/');
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    getSubmitform() {
        const styles = {
            fontSize: '18px',
          };

        const noteProps = {
            value: this.state.note,
            onChange: this.handleChange,
        }

        var buttonText = "Submit";
        if (this.isReadOnly())
            buttonText = "Request";
        
        return (
            <form onSubmit={this.handleSubmit} style={styles}>

                <label>
                    Points to add:
                <input
                        style={styles}
                        name="pointsToAdd"
                        type="number"
                        max="99999"
                        min="-9999"
                        value={this.state.pointsToAdd}
                        onChange={this.handleChange} />
                </label>
                <br />
                <NoteInputField {... noteProps}/>

                <input type="submit" value={buttonText} style={styles}/>

            </form>
        );

        
    }

    showShareScore() {
        this.setState({
            showShareForm: !this.state.showShareForm,
            menuOpen: null,
        })
    }

    handleMenuChange(event){
        event.preventDefault()
        if (!this.state.menuOpen){
           this.setState({menuOpen: event.currentTarget}) 
        } else{
            this.setState({menuOpen: null})
        }
    }

    render() {
        const classes = this.props.classes;
        const listItems = this.state.personHistoryFS.map((docSnapshot) =>{
            const data = docSnapshot.data();
            let pointsColor = 'LimeGreen'
            if (data.pointsAdd < 0) pointsColor = 'red'
            const color = { color: pointsColor}
            const smallFont = {fontSize: 'x-small'}
            let backgroundColor = null;
            let pointsAddLable = 'Point add:'
            if (data.isRequest) {
                backgroundColor = {backgroundColor : '#ffe0b3'};
                pointsAddLable = 'Point requested:'
            }
            const backgroundNoPadding = Object.assign({},noPadding, backgroundColor);
            return(
                <ListItem key={docSnapshot.id} style={backgroundNoPadding} divider>
                    <Grid container direction="column" style={noPadding}>                        
                        <Grid container direction="row" justify="space-between">
                            <div>  points before: <strong>{data.pointsBefore}</strong></div>
                            <div > {pointsAddLable} <strong style= {color}>{data.pointsAdd}</strong> </div>                  
                        </Grid>
                        <Grid container direction="row" justify="space-between">
                            <div>
                                <ListItemText secondary="Note:"/>                                        
                            </div>
                            <div>
                                {data.created?moment(data.created.toDate()).fromNow():null}
                            </div>                                    
                        </Grid>
                        <div>
                            <ListItemText primary={data.note} />
                        </div>                          
                        <div style= {smallFont}>
                            Created by: {data.changedByEmail}
                        </div>
                    </Grid>
                </ListItem>

            );
        });

        let shareProps = {
            handleCancel: this.showShareScore,
            docId: this.props.match.params.id,
            accountName: "not known",
        };

        let personItem = null;
        if (this.state.personFS) {
            const data = this.state.personFS.data();
            shareProps['accountName'] = data.personName;
            personItem = (
                <div>
                    <strong>{data.personName} {data.points}</strong>
                </div>
            )
        };

        
        let propMenuItems =[
            ['Delete account', (event)=> {DeleteScore(this.props.match.params.id,this.isReadOnly(), event);
                this.props.history.push('/');}]
        ];
        if (!this.isReadOnly()){
            propMenuItems.push(['Share account', this.showShareScore])
        }
        const propMenuHandlers = {
            propMenuItems: propMenuItems,
            propHandleMenu: this.handleMenuChange,
            propMenuState: this.state.menuOpen
        }

        return (            
            <div>
                <ButtonAppBar propMenuHandlers = {propMenuHandlers}/>
                {this.state.showShareForm? <ShareScore {...shareProps}/>: null}
                {personItem}
                {this.getSubmitform()}
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center">
                <div className={classes.root}>
                    <List component="nav">
                        {listItems}
                    </List>
                </div>
                </Grid>
            </div>
        );
    }

}

export default withStyles(styles)(PersonFocus);



// WEBPACK FOOTER //
// ./src/components/PersonFocus.js